import { List } from 'antd';

const StepProgressList = ({ steps, stepIndex }) => (
  <List
    dataSource={steps}
    renderItem={(step, index) => (
      <List.Item>
        {index >= stepIndex
          ? step.renderPreprocess()
          : step.renderPostprocess()}
      </List.Item>
    )}
  />
);

export default StepProgressList;
